module.exports = __webpack_public_path__ + "media/sound_error.368f31b1.mp3";